const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M4.1,4.7h2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.3,4.7h2.2c0.5,0,0.9,0.4,0.9,0.9v11.2 c0,0.5-0.4,0.9-0.9,0.9H4.1c-0.5,0-0.9-0.4-0.9-0.9V8.6"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 7.6,
    y1: 4.7,
    x2: 13,
    y2: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M4.9,7.8H16c0.3,0,0.6,0.3,0.6,0.6v8 c0,0.3-0.3,0.6-0.6,0.6H4.6C4.3,17,4,16.7,4,16.4V8.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.7,11h-1.3c-0.1,0-0.1-0.1-0.1-0.1V9.7 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1V11C15.8,11,15.8,11,15.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.3,11H12c-0.1,0-0.1-0.1-0.1-0.1V9.7 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1V11C13.4,11,13.4,11,13.3,11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.9,11H9.6c-0.1,0-0.1-0.1-0.1-0.1V9.7 c0-0.1,0.1-0.1,0.1-0.1h1.3C11,9.6,11,9.7,11,9.7V11C11.1,11,11,11,10.9,11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.6,11H7.3c-0.1,0-0.1-0.1-0.1-0.1V9.7 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1V11C8.7,11,8.7,11,8.6,11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.7,13.4h-1.3c-0.1,0-0.1-0.1-0.1-0.1V12 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C15.8,13.3,15.8,13.4,15.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.3,13.4H12c-0.1,0-0.1-0.1-0.1-0.1V12 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C13.4,13.3,13.4,13.4,13.3,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.9,13.4H9.6c-0.1,0-0.1-0.1-0.1-0.1V12 c0-0.1,0.1-0.1,0.1-0.1h1.3C11,11.9,11,12,11,12v1.3C11.1,13.3,11,13.4,10.9,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.6,13.4H7.3c-0.1,0-0.1-0.1-0.1-0.1V12 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C8.7,13.3,8.7,13.4,8.6,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.2,13.4H4.9c-0.1,0-0.1-0.1-0.1-0.1V12 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C6.3,13.3,6.3,13.4,6.2,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.7,15.7h-1.3c-0.1,0-0.1-0.1-0.1-0.1v-1.3 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C15.8,15.7,15.8,15.7,15.7,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.3,15.7H12c-0.1,0-0.1-0.1-0.1-0.1v-1.3 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C13.4,15.7,13.4,15.7,13.3,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.9,15.7H9.6c-0.1,0-0.1-0.1-0.1-0.1v-1.3 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C11.1,15.7,11,15.7,10.9,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.6,15.7H7.3c-0.1,0-0.1-0.1-0.1-0.1v-1.3 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C8.7,15.7,8.7,15.7,8.6,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.2,15.7H4.9c-0.1,0-0.1-0.1-0.1-0.1v-1.3 c0-0.1,0.1-0.1,0.1-0.1h1.3c0.1,0,0.1,0.1,0.1,0.1v1.3C6.3,15.7,6.3,15.7,6.2,15.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 3.2,
    cy: 6.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M4.5,7H3V5.3c0-0.1,0-0.1,0.1-0.1s0.1,0,0.1,0.1v1.4h1.3c0.1,0,0.1,0,0.1,0.1S4.6,7,4.5,7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.3,6.2H6.7C6.5,6.2,6.4,6,6.4,5.9V3.3 C6.4,3.2,6.5,3,6.7,3h0.6c0.2,0,0.3,0.1,0.3,0.3v2.5C7.6,6,7.5,6.2,7.3,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14,6.2h-0.6C13.2,6.2,13,6,13,5.9V3.3 C13,3.2,13.2,3,13.3,3H14c0.2,0,0.3,0.1,0.3,0.3v2.5C14.3,6,14.2,6.2,14,6.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedules);
export default __webpack_public_path__ + "static/media/schedules.b54486828852496930925a947c6332ee.svg";
export { ForwardRef as ReactComponent };